import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// Routing
import { FormsRoutingModule } from './forms-routing.module';

@NgModule({
  imports: [
    FormsRoutingModule
  ],
  declarations: []
})
export class FormsModule { }
